import { IPredicate } from '@centra/centra-ui/dist'
import { Dispatch, SetStateAction } from 'react'

export const updatePinnedFilters = (
  pinnedFilters: string | null,
  filterName: string,
  setPinnedFilters: Dispatch<SetStateAction<string | null>>,
  setIsPinned: Dispatch<SetStateAction<boolean>>
) => {
  if (pinnedFilters) {
    try {
      const pinnedFiltersArr = JSON.parse(pinnedFilters)
      if (pinnedFiltersArr.includes(filterName)) {
        const newPinnedFiltersArr = pinnedFiltersArr.filter((el: string) => el !== filterName)
        setPinnedFilters(JSON.stringify(newPinnedFiltersArr))
        setIsPinned(false)
      } else {
        pinnedFiltersArr.push(filterName)
        setIsPinned(true)
        setPinnedFilters(JSON.stringify(pinnedFiltersArr))
      }
    } catch (error) {
      console.error(error)
    }
  } else {
    setIsPinned(true)
    setPinnedFilters(JSON.stringify([filterName]))
  }
}
interface IUpdateInputAndDateProps {
  predicate: IPredicate[]
  setInputValue?: Dispatch<SetStateAction<string>>
}
export const updateInputValue = ({ predicate, setInputValue }: IUpdateInputAndDateProps) => {
  const trimmedValue = predicate.find(el => el.field === 'taskId')?.values[0].trim()
  if (Number(trimmedValue) || Number(trimmedValue) === 0) {
    setInputValue?.(trimmedValue)
  }
}
